import { isMeetingSessionRoleGreaterThanOrEqual, MeetingContainerAPI, useMeetingNetworkQuality } from "@kalyzee/kast-web-sdk";
import { MeetingSessionRole } from "@kalyzee/kast-web-sdk/websocket";
import { throttle } from "lodash";
import { useEffect, useMemo, useRef } from "react";
import { sdkClient } from "../helpers/sdk";
import { useMeetingSelector } from "./meeting";

export const useScoreReporter = (
  container?: MeetingContainerAPI,
) => {
  const [_, meetingIdRef] = useMeetingSelector(container, state => state.meeting?.id);
  const lastReportedScore = useRef(-1);

  const score = -1;/*useMeetingNetworkQuality(container, (session, _, mode) => {
    return mode === "output" || isMeetingSessionRoleGreaterThanOrEqual(session.role, MeetingSessionRole.MODERATOR);
  });*/

  const debouncedReport = useMemo(() => {
    return throttle((value: number) => {
      if (!meetingIdRef.current) return;
      if (value < 0) return; // invalid value
      if (value === lastReportedScore.current) return; // No change, do not report
      lastReportedScore.current = value;
      const websocket = sdkClient.getWebsocketClient();
      websocket.emitter.meeting.createNetworkReport({
        id: meetingIdRef.current,
        videoScore: value,
      });
    }, 15000);
  }, []);

  useEffect(() => {
    const normalizedScore = Math.round(score / 5); // 0 or 1
    debouncedReport(normalizedScore);
  }, [score]);
}